module.exports = __webpack_public_path__ + "frozen-dbc40.svg";